<template>
  <div :class="classes">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    isFlex: {
      type: Boolean,
      default: false
    },

    flexDirection: {
      type: String,
      default: 'column',
      validator: (value) => {
        return ['column', 'row'].includes(value)
      }
    },

    isColumnOnMobile: {
      type: Boolean,
      default: false
    },

    gap: {
      type: String,
      default: '0'
    },

    alignItems: {
      type: String,
      default: 'normal',
      validator: (value) => {
        return ['normal', 'center', 'end'].includes(value)
      }
    },

    justifyContent: {
      type: String,
      default: 'start',
      validator: (value) => {
        return ['start', 'center', 'space-between', 'end'].includes(value)
      }
    },

    p: {
      type: String,
      default: '0'
    },
    px: {
      type: String,
      default: '0'
    },
    py: {
      type: String,
      default: '0'
    },
    pt: {
      type: String,
      default: '0'
    },
    pb: {
      type: String,
      default: '0'
    },
    m: {
      type: String,
      default: '0'
    },
    mb: {
      type: String,
      default: '0'
    },
    mt: {
      type: String,
      default: '0'
    },
    ml: {
      type: String,
      default: '0'
    }
  },

  computed: {
    classes () {
      return [
        'commonBox',
        `commonBox_m-${this.m}`,
        `commonBox_mb-${this.mb}`,
        `commonBox_mt-${this.mt}`,
        `commonBox_ml-${this.ml}`,
        `commonBox_p-${this.p}`,
        `commonBox_px-${this.px}`,
        `commonBox_py-${this.py}`,
        `commonBox_pt-${this.pt}`,
        `commonBox_pb-${this.pb}`,
        `commonBox_${this.flexDirection}`,
        `commonBox_align-${this.alignItems}`,
        `commonBox_justify-${this.justifyContent}`,
        `commonBox_gap-${this.gap}`,
        {
          commonBox_flex: this.isFlex,
          commonBox_columnOnMobile: this.isColumnOnMobile
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.commonBox {
  &_flex {
    display: flex;

    &.commonBox_row {
      flex-direction: row;
    }

    &.commonBox_column {
      flex-direction: column;
    }

    &.commonBox_columnOnMobile {
      @include display-less(desktop) {
        flex-direction: column;
      }
    }
  }

  &_align-normal {
    align-items: normal;
  }
  &_align-center {
    align-items: center;
  }
  &_align-end {
    align-items: end;
  }

  &_justify-start {
    justify-content: start;
  }

  &_justify-center {
    justify-content: center;
  }

  &_justify-space-between {
    justify-content: space-between;
  }

  &_justify-end {
    justify-content: end;
  }

  &_gap-1 {
    gap: 4px;
  }
  &_gap-2 {
    gap: 8px;
  }
  &_gap-3 {
    gap: 12px;
  }
  &_gap-4 {
    gap: 16px;
  }
  &_gap-5 {
    gap: 20px;
  }
  &_gap-6 {
    gap: 24px;
  }
  &_gap-8 {
    gap: 32px;
  }
  &_gap-10 {
    gap: 40px;
  }

  &_p-1 {
    padding: 4px;
  }
  &_p-2 {
    padding: 8px;
  }
  &_p-3 {
    padding: 12px;
  }
  &_p-4 {
    padding: 16px;
  }
  &_p-6 {
    padding: 24px;
  }
  &_p-8 {
    padding: 32px;
  }
  &_p-10 {
    padding: 40px;
  }

  &_px-1 {
    padding-right: 4px;
    padding-left: 4px;
  }
  &_px-2 {
    padding-right: 8px;
    padding-left: 8px;
  }
  &_px-3 {
    padding-right: 12px;
    padding-left: 12px;
  }
  &_px-4 {
    padding-right: 16px;
    padding-left: 16px;
  }
  &_px-6 {
    padding-right: 24px;
    padding-left: 24px;
  }
  &_px-8 {
    padding-right: 32px;
    padding-left: 32px;
  }
  &_px-10 {
    padding-right: 40px;
    padding-left: 40px;
  }

  &_py-1 {
    padding-top: 4px;
    padding-bottom: 4px;
  }
  &_py-2 {
    padding-top: 8px;
    padding-bottom: 8px;
  }
  &_py-3 {
    padding-top: 12px;
    padding-bottom: 12px;
  }
  &_py-4 {
    padding-top: 16px;
    padding-bottom: 16px;
  }
  &_py-6 {
    padding-top: 24px;
    padding-bottom: 24px;
  }
  &_py-8 {
    padding-top: 32px;
    padding-bottom: 32px;
  }
  &_py-10 {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  &_pt-1 {
    padding-top: 4px;
  }
  &_pt-2 {
    padding-top: 8px;
  }
  &_pt-3 {
    padding-top: 12px;
  }
  &_pt-4 {
    padding-top: 16px;
  }
  &_pt-6 {
    padding-top: 24px;
  }
  &_pt-8 {
    padding-top: 32px;
  }
  &_pt-10 {
    padding-top: 40px;
  }

  &_pb-1 {
    padding-bottom: 4px;
  }
  &_pb-2 {
    padding-bottom: 8px;
  }
  &_pb-3 {
    padding-bottom: 12px;
  }
  &_pb-4 {
    padding-bottom: 16px;
  }
  &_pb-6 {
    padding-bottom: 24px;
  }
  &_pb-8 {
    padding-bottom: 32px;
  }
  &_pb-10 {
    padding-bottom: 40px;
  }

  &_m-1 {
    margin: 4px;
  }
  &_m-2 {
    margin: 8px;
  }
  &_m-3 {
    margin: 12px;
  }
  &_m-4 {
    margin: 16px;
  }
  &_m-6 {
    margin: 24px;
  }
  &_m-8 {
    margin: 32px;
  }
  &_m-10 {
    margin: 40px;
  }

  &_mb-1 {
    margin-bottom: 4px;
  }
  &_mb-2 {
    margin-bottom: 8px;
  }
  &_mb-3 {
    margin-bottom: 12px;
  }
  &_mb-4 {
    margin-bottom: 16px;
  }
  &_mb-6 {
    margin-bottom: 24px;
  }
  &_mb-8 {
    margin-bottom: 32px;
  }
  &_mb-10 {
    margin-bottom: 40px;
  }

  &_mt-1 {
    margin-top: 4px;
  }
  &_mt-2 {
    margin-top: 8px;
  }
  &_mt-3 {
    margin-top: 12px;
  }
  &_mt-4 {
    margin-top: 16px;
  }
  &_mt-6 {
    margin-top: 24px;
  }
  &_mt-8 {
    margin-top: 32px;
  }
  &_mt-10 {
    margin-top: 40px;
  }

  &_ml-1 {
    margin-left: 4px;
  }
  &_ml-2 {
    margin-left: 8px;
  }
  &_ml-4 {
    margin-left: 16px;
  }
  &_ml-6 {
    margin-left: 24px;
  }
  &_ml-8 {
    margin-left: 32px;
  }
  &_ml-10 {
    margin-left: 40px;
  }
}
</style>
